<template>
    <Drawner
        :isOpen="isOpen"
        @toggle="toggleMenu"
        v-if="
            authStore.$state.user.isAdmin ||
            (authStore.$state.user.isFleet && authStore.$state.user.hasSearch)
        "
    />
    <NavigationBar :isOpen="isOpen" @toggle="toggleMenu" />
</template>

<script setup>
import { useAuthStore } from '@/js/stores/authStore.js';
import Drawner from './partials/Drawner.vue';
import NavigationBar from './partials/NavigationBar.vue';

const authStore = useAuthStore();

const props = defineProps({
    isOpen: Boolean,
});

const emits = defineEmits(['toggle']);

const toggleMenu = () => {
    emits('toggle', !props.isOpen);
};
</script>
